import React, { useCallback, useMemo } from "react";
import { Tabs, Tab } from "@curves/ui-base";
import PropTypes from "prop-types";
import useTabState from "@util/hook/useTabState";

const CommonTabs = ({ tabs = [], activeTab: controlledActiveTab, onTabChange: controlledOnTabChange, ...rest }) => {
	const activeTab = controlledActiveTab || tabs[0]?.value || "";
	const { activeTab: internalActiveTab, handleTabChange: setInternalActiveTab } = useTabState(activeTab);
	const isControlled = controlledActiveTab !== undefined && controlledOnTabChange !== undefined;

	const handleTabChange = useCallback(
		(event, newValue) => {
			if (isControlled) {
				controlledOnTabChange(event, newValue);
			} else {
				setInternalActiveTab(newValue);
			}
		},
		// eslint-disable-next-line
		[isControlled, controlledOnTabChange]
	);

	// 僅以可序列化的 value、to 做 signature，避免 label（可能為 React node）造成 JSON 循環引用
	const tabsSignature = JSON.stringify(tabs.map(({ value, to }) => ({ value, to })));
	const tabsMemo = useMemo(
		() =>
			tabs.map(({ label = "", value, icon: IconComponent = null, component: Component, to }) => (
				<Tab
					key={value}
					className="py-3"
					label={
						<>
							{IconComponent && React.createElement(IconComponent, { className: "mr-2" })}
							{label}
						</>
					}
					value={value}
					component={Component}
					to={to}
				/>
			)),
		// eslint-disable-next-line
		[tabsSignature]
	);

	return (
		<Tabs value={internalActiveTab} onChange={handleTabChange} {...rest}>
			{tabsMemo}
		</Tabs>
	);
};

CommonTabs.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.node.isRequired,
			value: PropTypes.string.isRequired,
			// icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node, PropTypes.oneOf([null, undefined])]), Allen TODO: observe
			component: PropTypes.elementType,
			to: PropTypes.string,
		})
	),
	activeTab: PropTypes.string,
	onTabChange: PropTypes.func,
};

export default CommonTabs;
